<aside id="library-search">
<mat-form-field class="search-field" appearance="outline">
	<i class="fa fa-search search-icon" (click)="search()"></i>
	<input matInput type="text" class="search-input" [(ngModel)]="searchTerm" (keyup.enter)="search()">
</mat-form-field>
</aside>